$(window).on('load', function () {
  if (window.location.search.includes('?module=')) {
    window.smoothscroll('#' + window.location.search.replace('?module=', ''));
  }
});

window.smoothscroll = function (target) {
  const element = $(target);

  if (!element.length) {
    return;
  }

  let offset = element.offset().top;

  offset -= $('.top-bar').outerHeight();
  offset -= $('.header').outerHeight();

  $('html, body').animate({
    scrollTop: offset,
  });
};
